import React, { useState } from 'react';
import { getApi, postApi } from '../../../Services/apiService';
import { toast } from 'react-toastify';

const RolePermissions = ({ isLoading, setIsLoading, setError }) => {
  const [settingRoles, setSettingRoles] = useState([]);
  const [expandedRole, setExpandedRole] = useState(null);
  const [rolesPermissionData, setRolesPermissionData] = useState([]);

  const handleSelectChange = (moduleName, key, value) => {
    setRolesPermissionData((prevData) =>
      prevData.map((permission) =>
        permission.name === moduleName
          ? {
            ...permission,
            [key]: value === "" ? null : Number(value)
          }
          : permission
      )
    );
  };

  const fetchRoles = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const resp = await getApi('/roles');
      if (resp?.success === true) {
        setSettingRoles(resp?.data?.roles);
      }
    } catch (error) {
      const errorMsg = error.message || 'Failed to fetch roles';
      setError(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleRoleAccordion = async (roleId) => {
    if (expandedRole === roleId) {
      setExpandedRole(null);
    } else {
      try {
        setIsLoading(true);
        setError(null);
        setExpandedRole(roleId);
        const resp = await getApi(`/roles/${roleId}/permissions`);
        if (resp?.success === true) {
          setRolesPermissionData(resp?.data?.permissions);
         
        }
      } catch (error) {
        const errorMsg = error.message || 'Failed to fetch permissions';
        setError(errorMsg);
       
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleSavePermissions = async () => {
    if (!expandedRole) return;

    try {
      setIsLoading(true);
      setError(null);
      const permissionsData = {};
      rolesPermissionData.forEach(permission => {
        permissionsData[permission.id] = {
          add: permission.add || 0,
          view: permission.view || 0,
          update: permission.update || 0,
          delete: permission.delete || 0
        };
      });

      const payload = {
        permissions: permissionsData
      };

      const resp = await postApi(`/roles/${expandedRole}/permissions`, payload);
      if (resp?.success === true) {
        toast.success(resp.msg || 'Permissions saved successfully');
        fetchRoles();
      } else {
        toast.error(resp.msg || 'Failed to save permissions');
      }
    } catch (error) {
      const errorMsg = error.message || 'Failed to save permissions';
      setError(errorMsg);
      toast.error(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch roles on component mount
  React.useEffect(() => {
    fetchRoles();
  }, []);

  return (
    <div className='setting-inner'>
      {isLoading && !expandedRole ? (
        <div className="text-center py-3">
          <div className="spinner-border spinner-border-sm" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        settingRoles?.map((role) => (
          <div key={role.id} className="role-permission-accordion">
            <div
              className={`role-permission-card ${expandedRole === role.id ? 'expanded' : ''}`}
              onClick={() => role.is_editable !== 0 && !isLoading && toggleRoleAccordion(role.id)}
            >
              <div className="left-content">
                <h2>{role.description}</h2>
                <p>{role.users_count} Member</p>
              </div>
              <div className="right-content">
                {role.is_editable == 0 ? (
                  <p>Admin permissions can not be changed</p>
                ) : (
                  <span className='permission-role'>
                    <img src={window.getPublicUrl("/assets/images/permision.png")} alt="" />
                    Permissions
                    <i className={`fas fa-chevron-${expandedRole === role.id ? 'up' : 'down'}`}></i>
                  </span>
                )}
              </div>
            </div>

            {expandedRole === role.id && (
              <div className='permission-table-inner seetting-permit'>
                {isLoading ? (
                  <div className="text-center py-3">
                    <div className="spinner-border spinner-border-sm" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <>
                    <table className="custom-table table-striped permission-table roles">
                      <thead>
                        <tr>
                          <th className="module">Module</th>
                          <th className="add">Add</th>
                          <th className="view">View</th>
                          <th className="update">Update</th>
                          <th className="delete">Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rolesPermissionData.map((module, index) => (
                          <tr key={index}>
                            <td className="module">{module?.description}</td>
                            <td>
                              <div className="custom-select">
                                <select
                                  onChange={(e) => handleSelectChange(module?.name, 'add', e.target.value)}
                                  value={module?.add === null ? "" : module?.add}
                                  disabled={isLoading}
                                >
                                  <option value="" disabled>select</option>
                                  <option value="0">Inactive</option>
                                  <option value="1">Active</option>
                                </select>
                              </div>
                            </td>
                            <td>
                              <div className="custom-select">
                                <select
                                  onChange={(e) => handleSelectChange(module?.name, 'view', e.target.value)}
                                  value={module?.view === null ? "" : module?.view}
                                  disabled={isLoading}
                                >
                                  <option value="" disabled>select</option>
                                  <option value="0">Inactive</option>
                                  <option value="1">Active</option>
                                </select>
                              </div>
                            </td>
                            <td>
                              <div className="custom-select">
                                <select
                                  onChange={(e) => handleSelectChange(module?.name, 'update', e.target.value)}
                                  value={module?.update === null ? "" : module?.update}
                                  disabled={isLoading}
                                >
                                  <option value="" disabled>select</option>
                                  <option value="0">Inactive</option>
                                  <option value="1">Active</option>
                                </select>
                              </div>
                            </td>
                            <td>
                              <div className="custom-select">
                                <select
                                  onChange={(e) => handleSelectChange(module?.name, 'delete', e.target.value)}
                                  value={module?.delete === null ? "" : module?.delete}
                                  disabled={isLoading}
                                >
                                  <option value="" disabled>select</option>
                                  <option value="0">Inactive</option>
                                  <option value="1">Active</option>
                                </select>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <button
                      className='save float-end'
                      onClick={handleSavePermissions}
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Saving...
                        </>
                      ) : 'Save'}
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default RolePermissions;